import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TemplatesHero from '../components/templates/TemplatesHero';
import TemplateCategories from '../components/templates/TemplateCategories';
import PopularTemplates from '../components/templates/PopularTemplates';
import TemplatesCTA from '../components/templates/TemplatesCTA';

const TemplatesPage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <TemplatesHero />
      <TemplateCategories />
      <PopularTemplates />
      <TemplatesCTA />
      <Footer />
    </div>
  );
};

export default TemplatesPage;